import Vue from "vue";
import Stringer from "../../packages/stringer/src/Stringer";

const getDefaultState = () => {
	return {
		alerts: [],
	};
};

const state = getDefaultState();

const actions = {
	reset({commit}) {
		commit("RESET");
	},
	alert({commit}, alert) {
		commit("alert", alert);
	},
	success({dispatch}, payload) {
		dispatch("alert", {
			autohide: true,
			dismissable: true,
			type: "success",
			messages: {
				single: payload,
			},
		});
	},
	formError({dispatch}, errors) {
		let message = new Stringer("There ? in the form").nGetText("is an error", "are errors", Object.keys(errors).length).value;

		dispatch("alert", {
			autohide: true,
			dataType: "formError",
			dismissable: true,
			incrementable: false,
			type: "danger",
			messages: {
				single: message,
			},
		});
	},
};

const mutations = {
	RESET(state) {
		Object.assign(state, getDefaultState());
	},
	alert(state, alert) {
		let existingAlert = state.alerts.find(_alert => _alert.dataType === alert.dataType);
		if (
			!alert.incrementable ||
			state.alerts.indexOf(existingAlert) < 0
		) {
			alert.instances = 1;
			state.alerts.push(alert);
		} else {
			existingAlert.instances = existingAlert.instances + 1;
			Vue.set(state.alerts, state.alerts.indexOf(existingAlert), existingAlert);
		}
	},
	removeAlert(state, index) {
		state.alerts.splice(index, 1);
	},
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
};
